import { QViewerTextEdit } from "../CoreApp/QViewerTextEdit";

export function AddViewerMultiLineTextEdit(
  panel,
  xPos,
  yPos,
  width,
  height,
  blankMsg,
  maxLen,
  tabID,
  addBorder,
  numRows,
  listening
) {
  var te = new QViewerTextEdit();
  te.InitTextEdit(panel, xPos, yPos, width, height, blankMsg, maxLen, tabID, true);
  te.SetNumRows(numRows);
  te.SetListening(listening);
  te.fActiveSelection = true;
  te.fParentPanel = panel;
  return te;
}
